import { VehicleFormData } from './parking-modals.types'

export const MAX_VEHICLES = 7

export const EMPTY_VEHICLE: VehicleFormData = {
  color: '',
  // Note: Empty 'id' indicates that vehicle is just in local state and not persisted in the database.
  id: undefined,
  licensePlate: '',
  make: '',
  model: '',
  permitTag: '',
  residentId: null,
  source: '',
  year: '',
}
